export default __webpack_public_path__ + "static/media/image4.17391b7f.png";